import React from 'react';
import { Button, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import DHQTable from './DHQTable';

const DHQExpenses = () => {
    return (
        <Container>
            <Typography variant='h2' align='center'> DHQ Expenses </Typography>
            <Stack spacing={2} alignItems='center'>
                <Button variant='contained' color='primary' component={Link} to='/AddDHQDeposit'> Add Deposit </Button>
                <Button variant='contained' color='primary' component={Link} to='/AddDHQEpxense'> Add Expense </Button>
                <DHQTable/>
            </Stack>
        </Container>
    );
};

export default DHQExpenses;